import React from 'react';
import { ControlLink, Text } from '@moda/om';
import { OrderItemReturnPolicy } from '../../../constants';
import { OrderItemStatusGroup } from '../../../hooks/useReturn';
import { hrefFor } from '../../../routers';

interface Props {
  isReturnable: boolean;
  orderNumber?: string;
  returnPolicy: OrderItemReturnPolicy;
  statusGroup: OrderItemStatusGroup;
}

export const AccountOrderItemDetailsReturnSection: React.FC<Props> = ({
  isReturnable,
  orderNumber,
  returnPolicy,
  statusGroup
}) => {
  if (returnPolicy === OrderItemReturnPolicy.NotEligibleForReturn) {
    return (
      <section className="AccountOrderItemDetailsReturnSection">
        <Text treatment="body2" color="ink">
          Not eligible for returns
        </Text>
      </section>
    );
  }

  if (statusGroup === OrderItemStatusGroup.Shipped && !isReturnable) {
    return (
      <section className="AccountOrderItemDetailsReturnSection">
        <Text treatment="body2" color="ink">
          Not eligible for returns
        </Text>
      </section>
    );
  }

  if (statusGroup === OrderItemStatusGroup.Shipped && isReturnable && orderNumber) {
    return (
      <section className="AccountOrderItemDetailsReturnSection">
        <ControlLink
          to={hrefFor.RequestReturnPage({
            orderNumber
          })}
        >
          <Text treatment="body2" color="ink">
            Request Return
          </Text>
        </ControlLink>
      </section>
    );
  }

  return null;
};
